import { Box, type BoxProps, type LayoutProps } from '@chakra-ui/react'

import chakraTokenToVar from '@/utils/chakraTokenToVar'

import AvatarBase from './internal/AvatarBase'

type AvatarWithIconSize = 'xs' | 'sm' | 'md'

const SIZE_TO_UI_DETAILS: Record<
  AvatarWithIconSize,
  { boxSize: LayoutProps['width']; avatarSize: LayoutProps['width'] }
> = {
  xs: {
    boxSize: '18px',
    avatarSize: '12px',
  },
  sm: {
    boxSize: '32px',
    avatarSize: '21px',
  },
  md: {
    boxSize: '48px',
    avatarSize: '32px',
  },
}

export default function DiagonalAvatars({
  userA,
  userB,
  size,
  orientation = 'down',
  ...boxProps
}: {
  userA: React.ComponentProps<typeof AvatarBase>['user']
  userB: React.ComponentProps<typeof AvatarBase>['user']
  size: 'xs' | 'sm' | 'md'
  orientation?: 'up' | 'down'
} & BoxProps): JSX.Element {
  const { boxSize, avatarSize } = SIZE_TO_UI_DETAILS[size]

  return (
    <Box width={boxSize} height={boxSize} position="relative" {...boxProps}>
      <AvatarBase
        user={userA}
        cursor="default"
        outline={`2px solid ${chakraTokenToVar('bg')}`}
        position="absolute"
        top={0}
        left={orientation === 'up' ? undefined : 0}
        right={orientation === 'up' ? 0 : undefined}
        width={avatarSize}
        height={avatarSize}
      />
      <AvatarBase
        user={userB}
        cursor="default"
        outline={`2px solid ${chakraTokenToVar('bg')}`}
        position="absolute"
        bottom={0}
        right={orientation === 'up' ? undefined : 0}
        left={orientation === 'up' ? 0 : undefined}
        width={avatarSize}
        height={avatarSize}
      />
    </Box>
  )
}
